import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';

export default new Vuex.Store({
  state: {
    mode: null,
    logo: null,
    continueButton: null,
    skipButton: null,
    submitButton: null,
    closedText: null,
    welcomeText: null,
    agreementText: null,
    agreementAffirmation: null,
    agreementButton: null,
    phoneText: null,
    phoneSMSText: null,
    title: null,
    welcomeTitle: null,
    agreementTitle: null,
    phoneTitle: null,
    studyId: null,
    theme: {},
    errorReason: null,
  },
  mutations: {
    LOAD_STUDY: (state, study) => {
      Vue.set(state, 'logo', study.logo);
      Vue.set(state, 'continueButton', study.continue_button);
      Vue.set(state, 'skipButton', study.skip_button);
      Vue.set(state, 'submitButton', study.submit_button);
      Vue.set(state, 'closedText', study.closed_text);
      Vue.set(state, 'welcomeText', study.welcome_text);
      Vue.set(state, 'agreementText', study.agreement_text);
      Vue.set(state, 'agreementAffirmation', study.agreement_affirmation);
      Vue.set(state, 'agreementButton', study.agreement_button);
      Vue.set(state, 'phoneText', study.phone_text);
      Vue.set(state, 'phoneSMSText', study.phone_sms_text);
      Vue.set(state, 'welcomeTitle', study.welcome_page_title);
      Vue.set(state, 'agreementTitle', study.agreement_page_title);
      Vue.set(state, 'phoneTitle', study.phone_page_title);
      Vue.set(state, 'studyId', study.id);
      Vue.set(state, 'theme', {
        dark: study.dark_theme,
        backgroundColor: study.background_color,
        primaryColor: study.primary_color,
        secondaryColor: study.secondary_color,
        accentColor: study.accent_color,
        errorColor: study.error_color,
        infoColor: study.info_color,
        successColor: study.success_color,
        warningColor: study.warning_color,
      });
      document.title = study.welcome_page_title;
      Vue.set(state, 'mode', 'welcome');
      Vue.set(state, 'title', state.welcomeTitle);
    },
    SET_ERROR_REASON: (state, reason) => {
      Vue.set(state, 'errorReason', reason);
    },
    CHANGE_MODE: (state, mode) => {
      Vue.set(state, 'mode', mode);
      if (mode === 'agreement') {
        Vue.set(state, 'title', state.agreementTitle);
      } else if (mode === 'phone') {
        Vue.set(state, 'title', state.phoneTitle);
      }
    },
  },
  actions: {
    loadStudy(context) {
      const el = document.getElementById('__package__');
      const data = el.textContent;
      context.commit('LOAD_STUDY', JSON.parse(data));
    },
    changeMode(context, mode) {
      context.commit('CHANGE_MODE', mode);
    },
    enroll(context, phoneNumber) {
      const urlParams = new URLSearchParams(window.location.search);
      axios
        .post('/api/enroll/', {
          phone: phoneNumber,
          study: context.state.studyId,
          source: urlParams.get('source'),
          uuid: urlParams.get('uuid'),
          agreement: true,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        })
        .then(() => {
          if (window.fbq) {
            window.fbq('track', 'CompleteRegistration');
          }
          context.commit('CHANGE_MODE', 'complete');
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.reason) {
            context.commit('SET_ERROR_REASON', err.response.data.reason);
          }
          context.commit('CHANGE_MODE', 'error');
        });
    },
  },
  modules: {},
});
